
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import $ from 'jquery';
import SideMenu from '../Pages/SideMenu';
import Header from '../Pages/Header';
import Footer from '../Pages/Footer';
import Logout from '../Pages/Logout';
import * as XLSX from 'xlsx';
//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
//for modal
import 'bootstrap/dist/css/bootstrap.min.css';
import { MultiSelect } from "react-multi-select-component";
import { rmGetmasters, reportForRMTracking } from '../Utilities/URLCONSTANTS';
import { GetApiHeaders } from '../Utilities/NetworkUtilities';
import DatePicker from "react-datepicker";
import { CustomDatePickerInput, customstyles } from "../../src/Utilities/utils";
import Loader_Bulk from '../Utilities/Loader_Bulk';
import { Button, Modal } from "react-bootstrap";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Select from "react-select";
import searchIcon from "../images/search_icon.svg";
import {
    HiMiniArrowsUpDown,
    HiMiniArrowUp,
    HiMiniArrowDown,
} from "react-icons/hi2";
import Pagination from '../Utilities/Pagination';

//ProductMaster

const RMReport = ({ }) => {
    const [thCount, setThCount] = useState(0);
    const [selectedSubLocation, setSelectedSubLocation] = useState("");
    const [loaderImage, setLoaderImage] = useState(require('../images/rmloader.gif'));
    const [isLoading, setIsLoading] = useState(false);
    const [operations, setOpeartions] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [todayDate, settodayDate] = useState(new Date());


    //Drop downs
    //typeofwork
    const [getTypeOfWork, setGetTypeOfWork] = useState([]);
    const [selectedTypeOfWork, setSelectedTypeOfWork] = useState("");
    const [typeOfWork, setTypeWork] = useState([]);
    const [getData, setGetData] = useState([]);
    const [locationData, setlocationData] = useState("");
    const [locatinBasedsubLocation, setlocatinBasedsubLocation] = useState([]);
    //location
    const [sublocationDataOriginal, setsublocationDataOriginal] = useState([]);
    const [sublocationData, setsublocationData] = useState([]);
    const [errLocation, setErrLocation] = useState("");
    //sublocation
    const [subLocation, setSubLocation] = useState([]);
    const [errSubLocation, setErrSubLocation] = useState("");
    const [errTypeOfWork, setErrorTypeOfWork] = useState("");
    const [errorStartDate, setErrorStartDate] = useState("");
    const [errorEndDate, setErrorEndDate] = useState("");

    //general List
    const [generalList, setGeneralList] = useState();
    const [errgeneralWork, setErrGeneralWork] = useState("");
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]); // For filtered results
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
    const [searchTerm, setSearchTerm] = useState('');
    const [totalItems, setTotalItems] = useState();;
    const [permitType, setpermitType] = useState('');
    const [wmy, setwmy] = useState("");
    const [location, setLocation] = useState([]);
    const [SelectedLocation, setSelectedLocation] = useState('');
    const [WeekSelected, setWeekSelected] = useState('no');
    const [monthSelected, setmonthSelected] = useState('no');
    const [yearSelected, setYearSelected] = useState('no');
    const [allSelected, setAllSelected] = useState('yes');
    const [searchTermOption, setSearchTermOption] = useState('');
    const [submitResponse, setsubmitResponse] = useState("");
    const [showMsg, setShowMsg] = useState("false");
    const [showResponsePopup, setShowResponsePopup] = useState(false);

    const handleFilter = (searchTerm) => {
        setSearchTerm(searchTerm);
        if (data != null && data != undefined) {
            const filteredResults = data.filter((item) =>
                (item.empId && item.empId.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.role && item.role.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.emailId && item.emailId.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.mainFunction && item.mainFunction.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.subFunction && item.subFunction.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.costcenter && item.costcenter.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.reportingManagerName && item.reportingManagerName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.functionalLead && item.functionalLead.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.date && item.date.includes(searchTerm)) ||
                (item.requestId && item.requestId.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.location && item.location.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.location && item.location.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.subLocation && item.subLocation.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.typeOfWork && item.typeOfWork.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.requestedBy && item.requestedBy.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.requesterMobileNumber && item.requesterMobileNumber.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.requestedDate && item.requestedDate.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.accepterRejected && item.accepterRejected.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.approvedBy && item.approvedBy.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.approvedDate && item.approvedDate.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.acceptedByTechnician && item.acceptedByTechnician.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.technicianAcceptedDate && item.technicianAcceptedDate.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.technicianStatus && item.technicianStatus.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.completedBy && item.completedBy.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.completedDate && item.completedDate.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.completedByMobileNumber && item.completedByMobileNumber.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.technicianShiftName && item.technicianShiftName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.acceptedByTechnicianMobileNumber && item.acceptedByTechnicianMobileNumber.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.completedBy && item.completedBy.toLowerCase().includes(searchTerm.toLowerCase()))

            );
            setFilteredData(filteredResults);
        }
    };

    const getMasterData = async () => {
        const getData = rmGetmasters
        // const getData = getMasters;
        const headers = await GetApiHeaders();
        try {
            const responseGetData = await axios.get(getData, { headers })
            console.log("resssss,", responseGetData);
            setGetData(responseGetData.data.response)
            // setGeneralList(responseGetData.data.response.generalWorksList)
            setGetTypeOfWork(responseGetData.data.response.TypeOfWork)
            setlocationData(responseGetData.data.response.workLogLocation);
            setsublocationDataOriginal(responseGetData.data.response.workLogSubLocation);

        } catch (err) {
            console.log("getError", err)
        }
    }


    const handleSubLocation = (selectedSubLocation) => {
        if (selectedSubLocation.length > 0) {
            setErrSubLocation(""); // Clear error when user selects a valid sub-location
        }
        const labelNames = selectedSubLocation.map(item => item.label).join(', ');
        console.log("valueArray", labelNames);
        setSubLocation(selectedSubLocation);
        setSelectedSubLocation(labelNames);
    };



    let commaSeparatedString;
    if (Array.isArray(subLocation)) {
        commaSeparatedString = subLocation.join(',');
    } else if (typeof subLocation === 'string') {
        // If subLocation is a string, split it by comma to form an array
        commaSeparatedString = subLocation;
    } else {
        // Handle other cases or assign a default value
        commaSeparatedString = ''; // or any default value you want
        console.error('Error: a is not an array');
    }



    const filteredLocations = locatinBasedsubLocation.filter(item =>
        item.name.toLowerCase().includes(searchTermOption.toLowerCase())
    )

    const handleLocation = (selectedOptions) => {
        const subLocationsArray = [];
        const labelNames = selectedOptions
            ?.map((item) => item.label)
            .join(", ");
        console.log("Selected Location Labels:", labelNames);
        setLocation(selectedOptions);
        setSelectedLocation(labelNames);
        if (selectedOptions.length > 0) {
            setErrLocation("");
            console.log(sublocationDataOriginal, "selectedOptions --->");
            selectedOptions.forEach((selected) => {
                sublocationDataOriginal.forEach((item) => {
                    if (item.locationId === parseInt(selected.value)) {
                        subLocationsArray.push(item);
                    }
                });
            });
            setsublocationData(subLocationsArray);

            setSubLocation([]);
        } else {
            setsublocationData([]);
            setSubLocation([]);
        }
    };

    const handleClose = () => {
        setShowResponsePopup(false)
    };


    useEffect(() => {
        if (data != null && data != undefined) {
            var dtToday = new Date();
            var month = dtToday.getMonth() + 1;
            var day = dtToday.getDate();
            var year = dtToday.getFullYear();
            if (month < 10)
                month = '0' + month.toString();
            if (day < 10)
                day = '0' + day.toString();
            var maxDate = year + '-' + month + '-' + day;
            setFilteredData(data);
            setTotalItems(data.length);

        }
    }, [data]);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);


    const handleItemsPerPageChange = (e) => {
        const selectedValue = parseInt(e.target.value);
        setItemsPerPage(selectedValue);
        setCurrentPage(1); // Reset to the first page when changing items per page.
    };

    // const totalItems = data.length;

    const pageNumbers = [];
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1); i++) {
        pageNumbers.push(i);
    }

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const handleresponse = () => {
        setShowResponsePopup(false);
        window.location.reload();
    };

    const tableId = 'Content_data_table'; // Replace 'yourTableId' with the actual id of your table
    useEffect(() => {
        const table = document.getElementById(tableId);
        if (table) {
            const theadRow = table.querySelector('thead tr');
            const thCount = theadRow ? theadRow.querySelectorAll('th').length : 0;
            setThCount(thCount);
        } else {
            console.warn(`Table with id '${tableId}' not found.`);
        }
    }, [tableId]); // Run this effect only once when the component mounts


    const handlePrint = () => {
        const printWindow = window.open();
        const printContent = document.querySelector('.print-table');
        // Check if the printContent is available
        if (printContent) {
            printWindow.document.write('<html><head>' +
                '<meta charset="utf-8" />' +
                '<link rel="icon" href="/favicon.ico" />' +
                '<meta name="viewport" content="width=device-width, initial-scale=1" />' +
                '<meta name="theme-color" content="#000000" />' +
                '<meta name="description" content="Web site created using create-react-app" />' +
                '<title>R&M Reports</title>' +
                '<link href="css/sb-admin-2.min.css" rel="stylesheet">' +
                '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css">' +
                '<script defer src="/static/js/bundle.js"></script>' +
                '<style>' +
                '@media print {' +
                '  table {' +
                '    border-collapse: collapse;' +
                '    width: 100%;' +
                '    margin-bottom: 10px;' +
                '  }' +
                '  th, td {' +
                '    border: 1px solid #ddd;' +
                '    text-align: center;' +
                '  }' +
                '}' +
                '</style>' +
                '</head><body>');

            printWindow.document.write(printContent.innerHTML);
            printWindow.document.write('</body></html>');

            // Delay the print function to ensure styles are applied
            printWindow.setTimeout(() => {
                printWindow.print();
                printWindow.close();
            });
        } else {
            // Handle the case where printContent is not found  
            alert("print is not available");
        }
    }

    const exportToExcel = () => {
        const data = [

            [
                'S.no',
                "Emp-ID",
                "Role",
                "Email-ID",
                "Main Function",
                "Sub Function",
                "Cost Center",
                "Reporting Manager Name",
                "Functional Lead",
                'Request Id',
                'Site',
                'Location',
                'Type Of Work',
                'Requested By',
                'Requested Mobile number',
                'Requested Date',
                'Acceptor Status',
                'Approved/Rejected By Acceptor',
                'Approved/Rejected Date',
                'Accepted By',
                'Accepted Date',
                'Technician Status',
                'Completed By',
                'Completed Date',
                'Requester Remarks',
                'Accepter Remarks',
                'Technician Remarks',
                'Completed By MobileNumber ',
                'Technician ShiftName',
                'AcceptedBy Technician MobileNumber',
                // 'CompletedBy',
            ],

            // Custom headers
            // ...currentItems.map((item) => [
            ...filteredData.map((item, index) => [
                index + 1,
                item.empId,
                item.role,
                item.emailId,
                item.mainFunction,
                item.subFunction,
                item.costcenter,
                item.reportingManagerName,
                item.functionalLead,
                item.requestId,
                item.location,
                item.subLocation,
                item.typeOfWork,
                item.requestedBy,
                item.requesterMobileNumber,
                item.requestedDate,
                item.acceptorStatus,
                item.approvedBy || item.rejectedBy,
                item.approvedDate || item.rejectedDate,
                item.acceptedByTechnician,
                item.technicianAcceptedDate,
                item.technicianStatus,
                item.completedBy,
                item.completionDate,
                item.requesterRemarks,
                item.accepterRemarks,
                item.technicianRemarks,
                item.completedByMobileNumber,
                item.technicianShiftName,
                item.acceptedByTechnicianMobileNumber,
                // item.completedBy,
            ]),
        ];

        const ws = XLSX.utils.aoa_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'R&M Reports');
        // Save the file
        XLSX.writeFile(wb, 'R&M Reports.xlsx');
    };

    const handleWMYChange = (e) => {
        $('.date_show_hide').hide();
        let chk_val = (e.target.value);
        setwmy(chk_val);
        if (chk_val === 'M' || chk_val === 'Y' || chk_val === 'W' || chk_val === 'All') {
            setGeneralList('')
            setLocation([])
            setSubLocation([])
            setTypeWork([])
            setStartDate(new Date());
            setEndDate(new Date());
        }

        if (chk_val == 'W') {
            setWeekSelected('yes');
            setmonthSelected('no');
            setYearSelected('no');
            setAllSelected('no');
        }
        else if (chk_val == 'M') {
            setWeekSelected('no');
            setmonthSelected('yes');
            setYearSelected('no');
            setAllSelected('no');
        }
        else if (chk_val == 'Y') {
            setWeekSelected('no');
            setmonthSelected('no');
            setYearSelected('yes');
            setAllSelected('no');
        }
        else if (chk_val == 'All') {
            setwmy("");
            setWeekSelected('no');
            setmonthSelected('no');
            setYearSelected('no');
            setAllSelected('yes');
            $('.date_show_hide').show();
        }
    }


    const tableRef = useRef(null);
    useEffect(() => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            ordering: false,
        });
        getMasterData();

    }, []);


    const handleTypeOfWork = (selectedTypeOfWork) => {
        if (selectedTypeOfWork.length > 0) {
            setErrorTypeOfWork(""); // Clear error when user selects a valid sub-location
        }
        const labelNames = selectedTypeOfWork.map(item => item.label).join(', ');
        console.log("valueArray", labelNames)
        setTypeWork(selectedTypeOfWork);
        setSelectedTypeOfWork(labelNames);
    };



    const handleSubmit = async (event) => {
        event.preventDefault();

        let isValid = true; // Flag to track validation status

        if (location.length === 0) {
            setErrLocation("Please Select Location");
            isValid = false;
        }
        if (subLocation.length === 0) {
            setErrSubLocation("Please Select SubLocation");
            isValid = false;
        }

        if (typeOfWork.length === 0) {
            setErrorTypeOfWork("Please Select Type Of Work");
            isValid = false;
        }

        if (!startDate) {
            setErrorStartDate("Please Select From Date");
            isValid = false;
        }

        if (!endDate) {
            setErrorEndDate("Please Select To Date");
            isValid = false;
        }
        // If any validation fails, stop the form submission
        if (!isValid) {
            return;
        }

        let formattedStartDate = startDate ? startDate.toISOString().split('T')[0] : "";
        let formattedEndDate = endDate ? endDate.toISOString().split('T')[0] : "";

        const selectedLocationValues = location.map((loc) => loc.label).join(", ");

        const reqObj = {
            "WMY": wmy,
            "startDate": formattedStartDate,
            "endDate": formattedEndDate,
            "location": selectedLocationValues,
            "subLocation": selectedSubLocation,
            "typeOfWork": selectedTypeOfWork,
            "reportType": "requests",
        };

        const fetchApi = reportForRMTracking;
        const headers = await GetApiHeaders();
        console.log("Dynamic Headers::", headers);

        try {
            setIsLoading(true);
            const res = await axios.post(fetchApi, reqObj, { headers });
            const rmData = res?.data?.response?.requests;

            setData(rmData ? rmData : []);
            setIsLoading(false);
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    };


    const Sendmail = async (event) => {
        if (!location) {
            setErrLocation("Please Select Location")
        }

        let formattedStartDate = startDate;
        let formattedEndDate = endDate;

        if (startDate) {
            formattedStartDate = startDate.toISOString().split('T')[0];
        }
        if (endDate) {
            formattedEndDate = endDate.toISOString().split('T')[0];
        }

        event.preventDefault();
        const reqObj = {
            "WMY": wmy,
            "startDate": formattedStartDate,
            "endDate": formattedEndDate,
            "location": SelectedLocation,
            "subLocation": selectedSubLocation,
            "generalList": generalList,
            "typeOfWork": selectedTypeOfWork,
            "reportType": "requests"
        }
        const fetchApi = reportForRMTracking;
        const headers = await GetApiHeaders();

        try {
            if (location !== "") {
                setIsLoading(true);
                const response = await axios.post(fetchApi, reqObj, { headers })
                console.log('mail checking', response);
                setShowResponsePopup(true);
                setsubmitResponse(response.data.message);
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error);
            setIsLoading(false);

        }

    }

    function resetData(e) {
        e.preventDefault();
        const today = new Date();
        // Clear validation errors
        setErrGeneralWork("");
        setErrLocation("");
        setErrSubLocation("");
        setErrorTypeOfWork("");
        setErrorStartDate("");
        setErrorEndDate("");

        // Reset form
        setAllSelected("yes");
        $(".date_show_hide").show();

        setwmy("");
        setTypeWork([]);
        setLocation([]);
        setSubLocation([]);
        setlocatinBasedsubLocation([]);
        setsublocationDataOriginal([]);
        setsublocationData([]);
        setGeneralList("");
        setStartDate(today);
        setEndDate(today);
        settodayDate(today);
        getMasterData();
    }

    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    const sortedData = [...filteredData].sort((a, b) => {
        if (sortConfig.key) {
            const aValue = a[sortConfig.key];
            const bValue = b[sortConfig.key];

            // Check if values are numeric
            if (!isNaN(aValue) && !isNaN(bValue)) {
                return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
            }

            // Fallback for string comparison
            const aString = aValue?.toString().toLowerCase();
            const bString = bValue?.toString().toLowerCase();
            if (aString < bString) return sortConfig.direction === "asc" ? -1 : 1;
            if (aString > bString) return sortConfig.direction === "asc" ? 1 : -1;
            return 0;
        }
        return 0;
    });

    // Handle column sorting
    const handleSort = (key) => {
        setSortConfig((prevConfig) => ({
            key,
            direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
        }));
    };

    const renderSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return <HiMiniArrowsUpDown className="ms-1" size={16} style={{ cursor: "pointer" }} />;
        }
        return sortConfig.direction === "asc" ? (
            <HiMiniArrowUp className="ms-1" size={16} style={{ cursor: "pointer" }} />
        ) : (
            <HiMiniArrowDown className="ms-1" size={16} style={{ cursor: "pointer" }} />
        );
    };

    const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);


    return (
        <body id="page-top">
            {/*  <!-- Page Wrapper --> */}
            <div id="wrapper">
                {/*  <!-- Sidebar --> */}
                <SideMenu />
                {/*  <!-- End of Sidebar --> */}

                {/*  <!-- Content Wrapper --> */}
                <div id="content-wrapper" className="d-flex flex-column">

                    {/*  <!-- Main Content --> */}
                    <div id="content">
                        {/*  <!-- Topbar --> */}
                        <Header />
                        {/* ...Content Start... */}
                        <div>
                            <div className='container-fluid' style={{ backgroundColor: "#F7F8FA" }}>
                                <div className='card border-0' style={{ backgroundColor: "transparent" }}>
                                    <div className='card-body pt-4 pl-1'>
                                        <h5 className='Roles_text'>R&M Report</h5>
                                        <div className='mt-4'>
                                            <div className='d-flex gap-1 status_card'>
                                                <div className='card flex-grow-1' style={{
                                                    border: '1px solid #0000001A',
                                                    boxShadow: "0 0.1rem 0.3rem rgba(0, 0, 0, 0.1)"
                                                }}>
                                                    <div className='card-body' style={{ padding: "20px 20px" }}>

                                                        <form onSubmit={handleSubmit}>
                                                            <div className='row'>
                                                                <div className='col-md-3 col-12'>
                                                                    <label
                                                                        className="form-label font-weight-bold mt-1"
                                                                    >Select Date Duration :      </label>

                                                                    <div className="btn-group" id='filter-btn' role="group" aria-label="Basic radio toggle button group" onChange={handleWMYChange}>
                                                                        <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked={WeekSelected === 'yes'} value="W" />
                                                                        <label className="btn btn-outline-primary" for="btnradio1">Week</label>
                                                                        <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autocomplete="off" checked={monthSelected === 'yes'} value="M" />
                                                                        <label className="btn btn-outline-primary" for="btnradio2">Month</label>
                                                                        <input type="radio" className="btn-check" name="btnradio" id="btnradio3" autocomplete="off" checked={yearSelected === 'yes'} value="Y" />
                                                                        <label className="btn btn-outline-primary" for="btnradio3">Year</label>
                                                                        <input type="radio" className="btn-check" name="btnradio" id="btnradio4" autocomplete="off" checked={allSelected === 'yes'} value="All" />
                                                                        <label className="btn btn-outline-primary" for="btnradio4">All</label>
                                                                    </div>
                                                                </div>


                                                                <div className='col-md-3 col-12'>
                                                                    <label className="form-label font-weight-bold mt-1"
                                                                    >Site  </label>

                                                                    <MultiSelect
                                                                        options={
                                                                            getData.site !== undefined
                                                                                ? getData.workLogLocation.map((item) => ({
                                                                                    label: item.name,
                                                                                    value: item.code,
                                                                                }))
                                                                                : []
                                                                        }
                                                                        value={location}
                                                                        onChange={handleLocation}
                                                                        labelledBy="Select Locations"
                                                                        overrideStrings={{
                                                                            selectSomeItems: "Select Location",
                                                                        }}
                                                                        renderValue={(selected) => (
                                                                            <div>
                                                                                {selected?.map((selectedItem, index) => (
                                                                                    <span key={index}>{selectedItem?.label}</span>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    />
                                                                    <span style={{ color: 'red' }}>{errLocation}</span>
                                                                </div>

                                                                <div
                                                                    className='col-md-3 col-12'
                                                                    style={{ position: 'relative' }}>
                                                                    <label className="form-label font-weight-bold mt-1">Location</label>

                                                                    <MultiSelect
                                                                        options={sublocationData.map((item) => ({
                                                                            label: item.name,
                                                                            value: item.code,
                                                                        }))}
                                                                        value={subLocation}
                                                                        onChange={handleSubLocation}
                                                                        labelledBy="Select"
                                                                        overrideStrings={{ selectSomeItems: 'Select Sub Location' }}
                                                                        renderValue={(selected) => (
                                                                            <div>
                                                                                {selected?.map((selectedItem, index) => (
                                                                                    <span key={index}>{selectedItem?.name}</span>
                                                                                ))}
                                                                            </div>
                                                                        )} />
                                                                    <span style={{ color: 'red' }}>{errSubLocation}</span>

                                                                </div>
                                                                <div className='col-md-3 col-12 '  >
                                                                    <label className="form-label  font-weight-bold mt-1">Type Of Work</label>
                                                                    <MultiSelect
                                                                        options={getTypeOfWork.map((item) => ({
                                                                            label: item.name,
                                                                            value: item.code,
                                                                        }))}
                                                                        value={typeOfWork}
                                                                        onChange={handleTypeOfWork}
                                                                        labelledBy="Select"
                                                                        overrideStrings={{ selectSomeItems: 'Select Type Of Work' }}
                                                                        renderValue={(selected) => (
                                                                            <div>
                                                                                {selected?.map((selectedItem, index) => (
                                                                                    <span key={index}>{selectedItem?.name}</span>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    />
                                                                    <span style={{ color: 'red' }}>{errTypeOfWork}</span>
                                                                </div>
                                                                <div className='col-sm-3 col-12 date_show_hide'
                                                                    style={{ marginLeft: "25%" }}
                                                                >
                                                                    <div class="mb-3">
                                                                        <label for="startdate"
                                                                            className="form-label font-weight-bold mt-1"
                                                                        >From Date</label>
                                                                        <DatePicker showIcon className='form-control w-100'
                                                                            placeholderText="Select Start Date"
                                                                            selected={startDate}
                                                                            onChange={(date) => { setStartDate(date) }}
                                                                            maxDate={endDate}
                                                                            dateFormat="dd-MMM-yyyy"
                                                                            id="activitystartdate"
                                                                            name="activitystartdate"
                                                                            customInput={<CustomDatePickerInput />}
                                                                        />
                                                                    </div>
                                                                    <span style={{ color: 'red' }}>{errorStartDate}</span>
                                                                </div>

                                                                <div
                                                                    className='col-sm-3 col-12 date_show_hide'
                                                                >
                                                                    <div class="mb-3">
                                                                        <label
                                                                            className="form-label font-weight-bold mt-1"
                                                                            for="enddate">To Date</label>
                                                                        <span><DatePicker showIcon className='form-control w-100'
                                                                            placeholderText="Select End Date" selected={endDate}
                                                                            onChange={(date) => setEndDate(date)}
                                                                            // dateFormat="dd/MM/yyyy"
                                                                            dateFormat="dd-MMM-yyyy"
                                                                            minDate={startDate}
                                                                            maxDate={todayDate}
                                                                            name="activityenddate"
                                                                            customInput={<CustomDatePickerInput />}
                                                                        /></span>
                                                                    </div>
                                                                    <span style={{ color: 'red' }}>{errorEndDate}</span>
                                                                </div>
                                                            </div>

                                                            <div className='mt-2 d-flex w-full justify-content-center gap-2'>
                                                                <button class="btn btn-primary mr-0"
                                                                    style={{
                                                                        paddingLeft: "3rem",
                                                                        paddingRight: "3rem",
                                                                    }}
                                                                    type='submit'>Apply</button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger"
                                                                    style={{
                                                                        paddingLeft: "3rem",
                                                                        paddingRight: "3rem",
                                                                    }}
                                                                    onClick={resetData}
                                                                >
                                                                    Clear
                                                                </button>
                                                                <button
                                                                    disabled
                                                                    className="btn btn-secondary mr-0 buttons-excel buttons-html5"
                                                                    style={{
                                                                        paddingLeft: "3rem",
                                                                        paddingRight: "3rem",
                                                                        marginBottom: "0px",
                                                                    }}
                                                                    onClick={Sendmail}>Mail</button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className='card flex-grow-1 mt-2' style={{
                                            border: '1px solid #0000001A',
                                            boxShadow: "0 0.1rem 0.3rem rgba(0, 0, 0, 0.1)"
                                        }}>
                                            <div className='card-body' style={{ padding: "10px 10px" }}>

                                                <div className="d-flex justify-content-between align-items-center"
                                                    style={{ paddingBottom: 20 }}>
                                                    <div className="d-flex align-items-center">
                                                        <label className="mr-1">Show {' '}</label>
                                                        <Select
                                                            options={[
                                                                { value: 10, label: '10' },
                                                                { value: 20, label: '20' },
                                                                { value: 50, label: '50' },
                                                            ]}
                                                            value={{
                                                                value: itemsPerPage,
                                                                label: String(itemsPerPage),
                                                            }}
                                                            onChange={(selected) => {
                                                                setItemsPerPage(selected.value);
                                                                setCurrentPage(1);
                                                            }}
                                                            isSearchable={false}
                                                            styles={customstyles}
                                                        />
                                                        &nbsp;
                                                        <label>{' '} Entries</label>
                                                    </div>

                                                    <div className="d-flex align-items-center" style={{ marginLeft: '5%' }}>

                                                        {/* Search Input */}
                                                        <div className="position-relative d-inline-block">
                                                            <img
                                                                src={searchIcon}
                                                                alt="Search"
                                                                className="search-icon"
                                                            />
                                                            <input
                                                                type="search"
                                                                placeholder="Type to Search..."
                                                                value={searchTerm}
                                                                onChange={(e) => handleFilter(e.target.value)}
                                                                className="form-control search-input mr-1"
                                                            />
                                                        </div>

                                                        <div className="my-2 d-flex w-full justify-content-end gap-2">
                                                            <button className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                                                                onClick={exportToExcel}>
                                                                Download Excel
                                                            </button>
                                                            {/* <button
                                                                className="btn btn-primary"
                                                                style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
                                                                onClick={handlePrint}>
                                                                Print
                                                            </button> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="print-table"
                                                    style={{ overflowX: 'auto' }}>
                                                    <Table className="table table-bordered 
                                                    Content_data_table table-striped" id="Content_data_table"
                                                    >

                                                        <thead>
                                                            <tr>
                                                                <th className='text-center abc'>S.No</th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("empId")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Employee ID
                                                                        {renderSortIcon("empId")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("role")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Role
                                                                        {renderSortIcon("role")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("emailId")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Email-ID
                                                                        {renderSortIcon("emailId")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("mainFunction")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Main Function
                                                                        {renderSortIcon("mainFunction")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("subFunction")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Sub Function
                                                                        {renderSortIcon("subFunction")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("costcenter")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Cost Center
                                                                        {renderSortIcon("costcenter")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("reportingManagerName")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Reporting Manager-Name
                                                                        {renderSortIcon("reportingManagerName")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("functionalLead")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Functional-Lead
                                                                        {renderSortIcon("functionalLead")}
                                                                    </span>
                                                                </Th>

                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("requestId")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Request Id
                                                                        {renderSortIcon("requestId")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("location")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Site
                                                                        {renderSortIcon("location")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("subLocation")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Location
                                                                        {renderSortIcon("subLocation")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("typeOfWork")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Type Of Work
                                                                        {renderSortIcon("typeOfWork")}
                                                                    </span>
                                                                </Th>

                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("requestedBy")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Requested By
                                                                        {renderSortIcon("requestedBy")}
                                                                    </span>
                                                                </Th>

                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("requesterMobileNumber")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Requested MobileNumber
                                                                        {renderSortIcon("requesterMobileNumber")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("requestedDate")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Requested Date
                                                                        {renderSortIcon("requestedDate")}
                                                                    </span>
                                                                </Th>

                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("acceptorStatus")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Acceptor Status
                                                                        {renderSortIcon("acceptorStatus")}
                                                                    </span>
                                                                </Th>

                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("approvedBy || rejectedBy")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Approved/Rejected By
                                                                        {renderSortIcon("approvedBy || rejectedBy")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("approvedDate")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Approved/Rejected Date
                                                                        {renderSortIcon("approvedDate")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("acceptedByTechnician")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Accepted By
                                                                        {renderSortIcon("acceptedByTechnician")}
                                                                    </span>
                                                                </Th>

                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("technicianAcceptedDate")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Accepted Date
                                                                        {renderSortIcon("technicianAcceptedDate")}
                                                                    </span>
                                                                </Th>

                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("technicianStatus")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Technician Status
                                                                        {renderSortIcon("technicianStatus")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("completedBy")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Completed By
                                                                        {renderSortIcon("completedBy")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("completionDate")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Completed Date
                                                                        {renderSortIcon("completionDate")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("requesterRemarks")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Requester Remarks
                                                                        {renderSortIcon("requesterRemarks")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("accepterRemarks")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Acceptor Remarks
                                                                        {renderSortIcon("accepterRemarks")}
                                                                    </span>
                                                                </Th>

                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("technicianRemarks")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Technician Remarks
                                                                        {renderSortIcon("technicianRemarks")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("completedByMobileNumber")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Completed By MobileNumber
                                                                        {renderSortIcon("completedByMobileNumber")}
                                                                    </span>
                                                                </Th>

                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("technicianShiftName")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        Technician ShiftName
                                                                        {renderSortIcon("technicianShiftName")}
                                                                    </span>
                                                                </Th>
                                                                <Th
                                                                    className="text-center"
                                                                    onClick={() => handleSort("acceptedByTechnicianMobileNumber")}
                                                                >
                                                                    <span className="d-inline-flex align-items-center">
                                                                        AcceptedBy Technician MobileNumber
                                                                        {renderSortIcon("acceptedByTechnicianMobileNumber")}
                                                                    </span>
                                                                </Th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {currentItems && currentItems.length > 0 ? (
                                                                currentItems.map((item, index) => (
                                                                    <React.Fragment >
                                                                        <tr>
                                                                            <td className='text-center'  > {(currentPage - 1) * itemsPerPage + index + 1}</td>
                                                                            <td className='text-left'>{item.empId}</td>
                                                                            <td className='text-left'>{item.role}</td>
                                                                            <td className='text-left'>{item.emailId}</td>
                                                                            <td className='text-left'>{item.mainFunction}</td>
                                                                            <td className='text-left'>{item.subFunction}</td>
                                                                            <td className='text-left'>{item.costcenter}</td>
                                                                            <td className='text-left'>{item.reportingManagerName}</td>
                                                                            <td className='text-left'>{item.functionalLead}</td>
                                                                            <td className='text-left'>{item.requestId}</td>
                                                                            <td className='text-left'>{item.location}</td>
                                                                            <td className='text-left'>{item.subLocation}</td>
                                                                            <td className='text-left'>{item.typeOfWork}</td>
                                                                            <td className='text-left'>{item.requestedBy}</td>
                                                                            <td className='text-left'>{item.requesterMobileNumber}</td>
                                                                            <td className='text-left'>{item.requestedDate}</td>
                                                                            <td className='text-left'>{item.acceptorStatus}</td>
                                                                            <td className='text-left'>{item.approvedBy || item.rejectedBy}</td>
                                                                            <td className='text-left'>{item.approvedDate}</td>
                                                                            <td className='text-left'>{item.acceptedByTechnician}</td>
                                                                            <td className='text-left'>{item.technicianAcceptedDate}</td>
                                                                            <td className='text-left'>{item.technicianStatus}</td>
                                                                            <td className='text-left'>{item.completedBy}</td>
                                                                            <td className='text-left'>{item.completionDate}</td>
                                                                            <td className='text-left'>{item.requesterRemarks}</td>
                                                                            <td className='text-left'>{item.accepterRemarks}</td>
                                                                            <td className='text-left'>{item.technicianRemarks}</td>
                                                                            <td className='text-left'>{item.completedByMobileNumber}</td>
                                                                            <td className='text-left'>{item.technicianShiftName}</td>
                                                                            <td className='text-left'>{item.acceptedByTechnicianMobileNumber}</td>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={thCount} className='text-center' style={{ padding: 130 }}>No Data Available</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                                <div>
                                                    <Modal
                                                        show={showResponsePopup}
                                                        centered
                                                        backdrop="static"
                                                        keyboard={false}
                                                        size="md"
                                                    >
                                                        <Modal.Header className="border-0 d-flex justify-content-center">
                                                            <Modal.Title>
                                                                {" "}
                                                                <span className="modal_title">R & M</span>
                                                            </Modal.Title>
                                                            <Button
                                                                variant="link"
                                                                className="close btn btn-danger close_btn"
                                                                onClick={handleClose}
                                                            >
                                                                X
                                                            </Button>
                                                        </Modal.Header>
                                                        <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                                                            <div className="d-flex justify-content-center mb-3 font-weight-600">
                                                                {showMsg ? (
                                                                    <p style={{ color: "#4A7729" }}>
                                                                        {submitResponse}
                                                                    </p>
                                                                ) : null}
                                                            </div>
                                                            <div className="d-flex justify-content-center">
                                                                <Button
                                                                    variant="primary"
                                                                    className="d-flex justify-content-center cancel_button"
                                                                    onClick={handleresponse}
                                                                >
                                                                    Okay
                                                                </Button>
                                                                &nbsp;&nbsp;
                                                            </div>
                                                        </Modal.Body>
                                                    </Modal>
                                                </div>

                                                <div className='py-3'>
                                                    <div className='card data_tableCard'>
                                                        <div className='card-body'>
                                                            {/* Pagination */}
                                                            <Pagination
                                                                currentPage={currentPage}
                                                                totalItems={sortedData.length}
                                                                itemsPerPage={itemsPerPage}
                                                                currentItems={currentItems}
                                                                onPageChange={handlePageClick}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        {isLoading && <Loader_Bulk loading={isLoading} message={"Fetching Data. Please Wait..!"} loderimage={loaderImage} />}
                    </div>
                    {/* ...End of Main Content...*/}
                    {/* ...Footer...*/}
                    <Footer />
                    {/* ... End of Footer...  */}
                </div>
            </div>
            {/*  <!-- End of Page Wrapper -->
        <!-- Scroll to Top Button--> */}
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
            {/*  <!-- Logout Modal--> */}
            <Logout />
            {/* {!isUserLoggedIn && <Login />} */}
        </body>
    )
}

export default RMReport;
